module.exports = __webpack_public_path__ + "static/media/Hittite_icon_200px.c286be13.png";